import client from '../../providers/fetchClient'

export const getAllMartialTypes = () => client.get('/v3/marital-types')

export const getUnionTypes = () => client.get('/v3/union-types')
